import { render, staticRenderFns } from "./statement-modal.vue?vue&type=template&id=2a88a986"
import script from "./statement-modal.vue?vue&type=script&lang=js"
export * from "./statement-modal.vue?vue&type=script&lang=js"
import style0 from "./statement-modal.vue?vue&type=style&index=0&id=2a88a986&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports